export const decisionAidTabs = [
  {
    id: 'internet',
    label: 'Internetgebruik',
    content: {
      type: 'Div',
      _children: [
        {
          type: 'Heading',
          props: {
            variant: 'H3',
            as: 'h3',
            children: 'Internetgebruik',
            my: 6,
          },
        },
        {
          type: 'RadioCard',
          props: {
            _fieldName: 'internet.downloadSpeed',
            _label: 'Hoe ziet je internetgebruik eruit?',
            _labelProps: { my: 0 },
            _tooltip: 'Unkown',
            radios: [
              {
                value: '[20, 500]',
                title: 'Licht (vanaf 20 Mbit/s)',
                description:
                  'Kleine huishoudens waarin internet voornamelijk gebruikt wordt voor het bezoeken van websites op niet te veel apparaten tegelijk, hebben meestal genoeg aan een bandbreedte van 20 Mbit/s.',
                variant: 'main',
                mr: 2,
              },
              {
                value: '[50, 500]',
                title: 'Gemiddeld (vanaf 50 Mbit/s)',
                description:
                  'Gezin dat op meerdere apparaten tegelijk gebruik maakt van internet én graag video’s streamt, heeft een bandbreedte van tenminste 50 Mbit/s nodig.',
                variant: 'main',
                mr: 2,
              },
              {
                value: '[100, 500]',
                title: 'Zwaar (vanaf 100 Mbit/s)',
                description:
                  'Gezin dat graag in hoge kwaliteit video’s op meerdere apparaten tegelijkertijd willen streamen, heeft een bandbreedte nodig van minimaal 100 Mbit/s of meer.',
                variant: 'main',
                mr: 2,
              },
            ],
          },
        },
        {
          type: 'Div',
          props: {
            mt: 6,
            mb: [6, 6, 0],
            display: 'flex',
            flexDirection: ['column', 'row'],
            justifyContent: 'flex-end',
            alignItems: ['flex-end', null],
          },
          _children: [
            {
              type: 'SkipButton',
              props: {
                children: 'Overslaan',
                variant: 'secondary',
              },
            },
            {
              type: 'SubmitCurrentFormButton',
              props: {
                mt: [3, 0],
                ml: [0, 3],
                children: 'Volgende',
                variant: 'submitModalWithSteps',
              },
            },
          ],
        },
      ],
    },
  },
  {
    id: 'television',
    label: 'Televisie',
    content: {
      type: 'Div',
      _children: [
        {
          type: 'Heading',
          props: {
            variant: 'H3',
            as: 'h3',
            children: 'Televisie',
            my: 6,
          },
        },
        // {
        //   type: 'RadioGroup',
        //   props: {
        //     _fieldName: 'television.decoders',
        //     _label: 'Hoeveel televisies wil je aansluiten?',
        //     _tooltip: 'unknow',
        //     _labelProps: {
        //       my: 0,
        //     },
        //     radios: [
        //       {
        //         value: '[1]',
        //         label: '1 tv',
        //         variant: 'main',
        //         mr: 2,
        //       },
        //       {
        //         value: '[2]',
        //         label: "2 tv's",
        //         variant: 'main',
        //         mr: 2,
        //       },
        //       {
        //         value: '[3]',
        //         label: "3 tv's",
        //         variant: 'main',
        //         mr: 2,
        //       },
        //       {
        //         value: '[4]',
        //         label: "4 tv's",
        //         variant: 'main',
        //         mr: 2,
        //       },
        //       {
        //         value: '[5]',
        //         label: "5 tv's",
        //         variant: 'main',
        //         mr: 2,
        //       },
        //     ],
        //     containerProps: {
        //       variant: 'radio',
        //       flexDirection: 'row-reverse',
        //       justifyContent: 'flex-end',
        //     },
        //   },
        // },
        {
          type: 'Div',
          props: {
            mt: 6,
          },
          _children: [
            {
              type: 'RadioGroup',
              props: {
                _fieldName: 'television.withRecorder',
                _label: 'Wil je kunnen opnemen?',
                _tooltip: 'unknow',
                _labelProps: {
                  my: 0,
                },
                radios: [
                  {
                    value: 1,
                    label: 'Geen voorkeur',
                    variant: 'main',
                    mr: 2,
                  },
                  {
                    value: 2,
                    label: 'Ja, op minstens 1 TV',
                    variant: 'main',
                    mr: 2,
                  },
                ],
                containerProps: {
                  variant: 'radio',
                  flexDirection: 'row-reverse',
                  justifyContent: 'flex-end',
                },
              },
            },
          ],
        },
        {
          type: 'Div',
          props: {
            mt: 6,
            mb: 3,
          },
          _children: [
            {
              type: 'Inputs.LabelWithTooltip',
              props: {
                _label: 'Zijn er zenders die je absoluut niet wil missen?',
                _tooltip: 'unknown',
                _description:
                  'Standaard ontvang je bij elk pakket vaak al zo’n 60 zenders . Zijn er daarnaast nog zenders die je écht niet wilt missen, dan kan je dat hier aangeven.',
                _labelProps: {
                  my: 0,
                  mb: 1,
                },
              },
            },
          ],
        },
        {
          type: 'Div',
          props: { width: '240px', pb: 3 },
          _children: [
            {
              type: 'SpecificChannelSearch',
              props: {
                _fieldName: 'television.specificTvChannel',
                optionsFieldName: 'television.specificTvChannelOptions',
                _label: 'Specifieke zender',
                _tooltip: 'Unkown',
              },
            },
          ],
        },
        {
          type: 'CheckboxGroupWrapper',
          props: {
            _fieldName: 'television.extraChannelPackage',
            _label: 'Extra zenderpakketten',
            _tooltip: 'Unkown',
            options: [
              { label: 'Ziggo Sport Totaal', value: 'Ziggo Sport Totaal' },
              { label: 'ESPN Compleet', value: 'ESPN Compleet' },
              { label: 'Film1', value: 'Film1' },
            ],
          },
        },
        {
          type: 'Div',
          props: {
            mt: 6,
            mb: [6, 6, 0],
            display: 'flex',
            flexDirection: ['column', 'row'],
            justifyContent: 'flex-end',
            alignItems: ['flex-end', null],
          },
          _children: [
            {
              type: 'SkipButton',
              props: {
                children: 'Overslaan',
                variant: 'secondary',
              },
            },
            {
              type: 'SubmitCurrentFormButton',
              props: {
                mt: [3, 0],
                ml: [0, 3],
                children: 'Volgende',
                variant: 'submitModalWithSteps',
              },
            },
          ],
        },
      ],
    },
  },
  {
    id: 'call',
    label: 'Bellen (vast)',
    content: {
      type: 'Div',
      _children: [
        {
          type: 'Heading',
          props: {
            variant: 'H3',
            as: 'h3',
            children: 'Bellen (vast)',
            my: 6,
          },
        },
        {
          type: 'Div',
          props: {
            mt: 6,
          },
          _children: [
            // {
            //   type: 'CheckboxGroupWrapper',
            //   props: {
            //     _fieldName: 'call.bellen',
            //     _label: 'Wil je onbeperkt kunnen bellen?',
            //     _tooltip: 'Unkown',
            //     _description:
            //       'Als je veel belt kan het voordeliger zijn om een belbundel te nemen.',
            //     options: [
            //       {
            //         label: 'Ja, naar vaste nummers in Nederland',
            //         value: 'nationalLandline',
            //       },
            //       {
            //         label: 'Ja, naar mobiele nummers in Nederland',
            //         value: 'nationalMobile',
            //       },
            //     ],
            //   },
            // },
            {
              type: 'Div',
              props: {
                // mt: 6,
              },
              _children: [
                {
                  type: 'CheckboxGroupWrapper',
                  props: {
                    _fieldName: 'call.bellen',
                    _label: 'Wil je je huidige nummer behouden?',
                    _tooltip: 'Unkown',
                    _description:
                      'Als je overstapt naar een andere provider, of binnen dezelfde stad verhuist kan je je nummer behouden. Geef hier aan als dit gewenst is.',
                    options: [
                      {
                        label: 'Ja ik wil mijn nummer behouden',
                        value: 'keepNumber',
                      },
                    ],
                  },
                },
              ],
            },
          ],
        },

        {
          type: 'Div',
          props: {
            mt: 6,
            mb: [6, 6, 0],
            display: 'flex',
            flexDirection: ['column', 'row'],
            justifyContent: 'flex-end',
            alignItems: ['flex-end', null],
          },
          _children: [
            {
              type: 'SkipButton',
              props: {
                children: 'Overslaan',
                variant: 'secondary',
              },
            },
            {
              type: 'SubmitCurrentFormButton',
              props: {
                mt: [3, 0],
                ml: [0, 3],
                children: 'Volgende',
                variant: 'submitModalWithSteps',
              },
            },
          ],
        },
      ],
    },
  },
  {
    id: 'combinationDiscount',
    label: 'Combinatiekorting',
    content: {
      type: 'Div',
      _children: [
        {
          type: 'Heading',
          props: {
            variant: 'H3',
            as: 'h3',
            children: 'Combinatiekorting',
            my: 6,
          },
        },
        {
          type: 'P',
          props: {
            variant: 'bodyRegular',
            children:
              'Combineer je mobiele abonnement en je energie contract met je alles-in-1 abonnement en krijg extra korting op je maandprijs.',
            mb: 6,
          },
        },
        {
          type: 'CheckboxGroupWrapperApi',
          props: {
            _fieldName: 'combinationDiscount.mobileProvider',
            _label: 'Mobiele provider',
            handler: 'getCustomerBenefits',
            optionsFieldName: 'combinationDiscount.mobileProviderOptions',
          },
        },
        {
          type: 'Div',
          props: {
            mt: 6,
          },
          _children: [
            {
              type: 'CheckboxGroupWrapper',
              props: {
                _fieldName: 'combinationDiscount.energySupplier',
                _label: 'Energieleverancier',
                _tooltip: 'Unkown',
                options: [
                  {
                    label: 'Budget energie',
                    value: 12,
                  },
                ],
              },
            },
          ],
        },
        {
          type: 'Div',
          props: {
            mt: 6,
            mb: [6, 6, 0],
            display: 'flex',
            flexDirection: ['column', 'row'],
            justifyContent: 'flex-end',
            alignItems: ['flex-end', null],
          },
          _children: [
            {
              type: 'SubmitModalWithStepsButton',
              props: {
                forms: [
                  'internet',
                  'television',
                  'call',
                  'combinationDiscount',
                ],
                children: 'Toon resultaten',
                variant: 'submitModalWithSteps',
              },
            },
          ],
        },
      ],
    },
  },
];

export const combinationDiscount = {
  id: 'combinationDiscount',
  label: 'Combinatiekorting',
  content: {
    type: 'Div',
    _children: [
      {
        type: 'P',
        props: {
          variant: 'bodyRegular',
          children:
            'Combineer je mobiele abonnement en je energie contract met je alles-in-1 abonnement en krijg extra korting op je maandprijs.',
          mb: 6,
          pt: 3,
        },
      },
      {
        type: 'CheckboxGroupWrapperApi',
        props: {
          _fieldName: 'combinationDiscount.mobileProvider',
          _label: 'Je huidige mobiele provider',
          handler: 'getCustomerBenefits',
          optionsFieldName: 'combinationDiscount.mobileProviderOptions',
        },
      },
      {
        type: 'Div',
        props: {
          mt: 6,
        },
        _children: [
          {
            type: 'CheckboxGroupWrapper',
            props: {
              _fieldName: 'combinationDiscount.energySupplier',
              _label: 'Je huidige energieleverancier',
              options: [
                {
                  label: 'Budget energie',
                  value: 12,
                },
              ],
            },
          },
        ],
      },
      {
        type: 'Div',
        props: {
          mt: 6,
          mb: [6, 6, 0],
          display: 'flex',
          flexDirection: ['column', 'row'],
          justifyContent: 'flex-end',
          alignItems: ['flex-end', null],
        },
        _children: [
          {
            type: 'SubmitModalWithStepsButton',
            props: {
              forms: [
                'internet',
                'television',
                'telephone',
                'combinationDiscount',
              ],
              children: 'Toon resultaten',
              variant: 'submitModalWithSteps',
            },
          },
        ],
      },
    ],
  },
};
